module.exports = __webpack_public_path__ + "img/385.63f095e6.png";